export default __webpack_public_path__ + "static/media/title_th_pc.e4f4ccb1.png";